import React, { useEffect, useState } from 'react';

const loadInsuranceImage = () => {
  try {
    const raw = sessionStorage.getItem('insurance');
    if (!raw) return '';
    const parsed = JSON.parse(raw);
    return typeof parsed === 'string' ? parsed : '';
  } catch (error) {
    return '';
  }
};

const InsuranceHistoryImage = () => {
  const [src] = useState(loadInsuranceImage);
  const [enlarged, setEnlarged] = useState(false);

  useEffect(() => {
    if (!enlarged) return undefined;
    const onKeyDown = (event) => {
      if (event.key === 'Escape') setEnlarged(false);
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [enlarged]);

  if (!src) {
    return (
      <div style={{ padding: 24, textAlign: 'center', color: '#475569' }}>
        불러온 카히스토리 이미지가 없습니다.
      </div>
    );
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#f4f5f7',
        padding: '24px 16px',
        boxSizing: 'border-box',
      }}
    >
      <button
        type="button"
        onClick={() => setEnlarged(true)}
        aria-label="카히스토리 이미지 크게 보기"
        style={{
          display: 'block',
          margin: '0 auto',
          padding: 8,
          border: '1px solid #d0d5dd',
          borderRadius: 8,
          background: '#fff',
          cursor: 'zoom-in',
        }}
      >
        <img
          src={src}
          alt="카히스토리"
          style={{
            display: 'block',
            width: 280,
            maxWidth: '70vw',
            height: 360,
            objectFit: 'contain',
            objectPosition: 'top',
            background: '#fff',
          }}
        />
      </button>
      <p style={{ marginTop: 12, textAlign: 'center', color: '#667085', fontSize: 14 }}>
        이미지를 선택하면 크게 볼 수 있습니다.
      </p>

      {enlarged && (
        <div
          role="presentation"
          onClick={() => setEnlarged(false)}
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 1000,
            background: 'rgba(15, 23, 42, 0.82)',
            overflow: 'auto',
            padding: 24,
            boxSizing: 'border-box',
            cursor: 'zoom-out',
          }}
        >
          <button
            type="button"
            onClick={() => setEnlarged(false)}
            style={{
              position: 'fixed',
              top: 16,
              right: 16,
              zIndex: 1001,
              border: 0,
              borderRadius: 6,
              background: '#fff',
              padding: '8px 14px',
              cursor: 'pointer',
              fontSize: 14,
            }}
          >
            닫기
          </button>
          <img
            src={src}
            alt="카히스토리 크게 보기"
            onClick={(event) => event.stopPropagation()}
            style={{
              display: 'block',
              width: 'min(960px, 100%)',
              height: 'auto',
              margin: '40px auto 0',
              background: '#fff',
              cursor: 'default',
            }}
          />
        </div>
      )}
    </div>
  );
};

export default InsuranceHistoryImage;
